import script from "./TabAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./TabAccount.vue?vue&type=script&setup=true&lang=js"

import "./TabAccount.vue?vue&type=style&index=0&id=6356958b&scoped=true&lang=scss"

import exportComponent from "/home/deployer/deploypad/silogues/releases/20261022152544/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6356958b"]])

export default __exports__